export default "__VITE_ASSET__e76ef220__"